import { CSSObject } from "@emotion/react";

export const textCss: CSSObject = {
  pointerEvents: "none",
  whiteSpace: "nowrap",
  "::before": {
    display: "block",
    content: "attr(data-text)",
    fontWeight: 700,
    height: 0,
    overflow: "hidden",
    visibility: "hidden",
  },
};
